__turbopack_context__.v({
  "Anchor": "nav-item-module__Q80z8W__Anchor",
  "CardLink": "nav-item-module__Q80z8W__CardLink",
  "MenuItem": "nav-item-module__Q80z8W__MenuItem",
});
